import React from "react";

function ContactMe() {
  return (
    <section id="contact" className="contact-form-section">
      <div className="content-container contact-container">
        <div className="contact-svg-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-100"
            data-name="Layer 1"
            viewBox="0 0 1096 574.7"
          >
            <defs>
              <linearGradient
                id="a"
                x1="819.1"
                x2="819.1"
                y1="732.6"
                y2="560.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stopColor="gray" stopOpacity=".3" />
                <stop offset=".5" stopColor="gray" stopOpacity=".1" />
                <stop offset="1" stopColor="gray" stopOpacity=".1" />
              </linearGradient>
              <pattern
                id="b"
                width="36.9"
                height="49.5"
                data-name="New Pattern 3"
                patternUnits="userSpaceOnUse"
                viewBox="0 0 36.9 49.5"
              >
                <path fill="none" d="M0 0h36.9v49.5H0z" />
                <path d="M4.3 13.2c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M4.5 17.2c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M4.5 21c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M3.4 24.7c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M1 28.3l.3.4A3.5 3.5 0 0 0 6 29.9a3.6 3.6 0 0 0 1.2-4.8l-.2-.3a3.5 3.5 0 0 0-4.7-1.3A3.6 3.6 0 0 0 1 28.3z" />
                <path d="M1.5 30.1l.2.6a3.7 3.7 0 0 0 1.6 2 3.6 3.6 0 0 0 2.7.4 3.5 3.5 0 0 0 2.4-4.3l-.2-.6a3.7 3.7 0 0 0-1.6-2 3.6 3.6 0 0 0-2.7-.4A3.6 3.6 0 0 0 1.5 30z" />
                <path d="M1.6 33.9v.4A3.5 3.5 0 0 0 5 37.8a3.6 3.6 0 0 0 3.5-3.5v-.4A3.5 3.5 0 0 0 5 30.4a3.6 3.6 0 0 0-3.5 3.5z" />
                <path d="M4.9 42.3c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M1.8 42v.2a3.5 3.5 0 0 0 3.5 3.5 3.6 3.6 0 0 0 3.5-3.5V42a3.5 3.5 0 0 0-3.5-3.5A3.6 3.6 0 0 0 1.8 42z" />
                <path d="M6 49.3c4.5 0 4.5-7 0-7s-4.5 7 0 7zM10 14.1c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M6.6 21c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M8.5 27c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M8.5 29.3c4.5 0 4.5-7 0-7s-4.5 7 0 7zM15 33.8c4.4 0 4.4-7 0-7s-4.6 7 0 7z" />
                <path d="M9.8 38.5c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M10.6 45.1c4.5 0 4.5-7 0-7s-4.5 7 0 7z" />
                <path d="M10.6 49.5c4.5 0 4.5-7 0-7s-4.5 7 0 7zM12.8 18.1c2.6 0 2.6-4 0-4s-2.6 4 0 4z" />
                <path d="M13 20.4c2.6 0 2.6-4 0-4s-2.6 4 0 4z" />
                <path d="M13.1 21v.2a2 2 0 0 0 4 0V21a2 2 0 0 0-4 0z" />
                <path d="M15.1 25.9c2.6 0 2.6-4 0-4s-2.6 4 0 4zM16.6 11a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM21.7 16.6a1 1 0 0 0 0-2 1 1 0 0 0 0 2z" />
                <path d="M16.9 9v-.4a1 1 0 0 0-2 0v.3a1 1 0 0 0 2 0zM16.5 4.8v-.2a1 1 0 0 0-2 0v.2a1 1 0 0 0 2 0zM15.5 2a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM10.6 2a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM10.4 4.7a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM7.3 6.2a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM11.9 7.1h.4a1 1 0 0 0 0-2h-.4a1 1 0 0 0 0 2zM13.3 11l.5 1.3a1 1 0 0 0 1.4.4 1 1 0 0 0 .4-1.4L15 10a1 1 0 0 0-1.4-.4 1 1 0 0 0-.3 1.4zM18.4 19.3v.2a1 1 0 0 0 2 0v-.2a1 1 0 0 0-2 0zM20.7 25l.2.3c.5 1.2 2.3.1 1.7-1l-.2-.4c-.6-1.1-2.3-.1-1.7 1zM22.1 29.4a2.5 2.5 0 0 0-.8 1.8 1 1 0 0 0 2 0 .6.6 0 0 1 .2-.4 1 1 0 0 0 0-1.4 1 1 0 0 0-1.4 0zM20.3 33.4l-.5 1.7c-.4 1.2 1.5 1.8 2 .5l.5-1.7c.3-1.2-1.6-1.7-2-.5zM19.4 37h-.1a1 1 0 0 0 0 2h.1a1 1 0 0 0 0-2zM17.6 41.5l-.2.4c-.5 1.1 1.2 2.1 1.8 1l.2-.4c.5-1.1-1.2-2.2-1.8-1zM15.8 47.9v.5a1 1 0 0 0 2 0V48a1 1 0 0 0-2 0zM14.3 49.4a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM14.3 41.3a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM17.1 36.5a2 2 0 0 0 1-1.7 1 1 0 0 0-2 0c0-.1.2-.2 0 0-1.1.5-.1 2.3 1 1.7zM17.4 31.3a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM18.1 28.5a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM19 25l.2-.4c.6-1.2-1.2-2.2-1.7-1l-.2.3c-.6 1.2 1.1 2.2 1.7 1zM18 16a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM24.6 16l.6 1a1 1 0 0 0 1.7-1l-.5-1a1 1 0 0 0-1.8 1zM34.9 29.7v.2a1 1 0 0 0 2 0v-.2a1 1 0 0 0-2 0zM24 39.2a1 1 0 0 0 0-2 1 1 0 0 0 0 2zM22.9 29a1 1 0 0 0 0-2 1 1 0 0 0 0 2z" />
                <path d="M18.2 21.9l.6-.6c1-.9-.5-2.3-1.4-1.4l-.6.6c-1 .9.5 2.3 1.4 1.4z" />
              </pattern>
              <linearGradient
                id="c"
                x1="462.9"
                x2="462.9"
                y1="660.7"
                y2="559.7"
              />
            </defs>
            <g opacity=".1">
              <ellipse
                cx="479.4"
                cy="362.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#3f3d56"
                d="M488.4 298.4a18 18 0 0 0 2.4-9.1c0-8.3-5-15-11.4-15s-11.4 6.8-11.4 15a18 18 0 0 0 2.4 9 18.6 18.6 0 0 0 0 18.3 18.6 18.6 0 0 0 0 18.2 18 18 0 0 0-2.4 9.1c0 8.2 5.1 15 11.4 15s11.4-6.8 11.4-15a18 18 0 0 0-2.4-9 18.6 18.6 0 0 0 0-18.3 18.6 18.6 0 0 0 0-18.2z"
              />
              <ellipse
                cx="479.4"
                cy="271.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <ellipse
                cx="479.4"
                cy="252.9"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#6c63ff"
                d="M436.8 128.2a53 53 0 0 1-4.2-6.2l29.9-5-32.4.3a54.6 54.6 0 0 1-1-43.2l43.4 22.5-40-29.4a54.5 54.5 0 1 1 90 61 54.5 54.5 0 0 1 6.2 10L490 158.4l41.4-14a54.5 54.5 0 0 1-8.8 51.3 54.5 54.5 0 1 1-85.7 0 54.5 54.5 0 0 1 0-67.4z"
              />
              <path
                d="M534.2 162a54.3 54.3 0 0 1-11.7 33.6 54.5 54.5 0 1 1-85.7 0c-7.3-9.2 97.4-39.8 97.4-33.7z"
                opacity=".1"
              />
            </g>
            <g opacity=".1">
              <ellipse
                cx="612.3"
                cy="330.3"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#3f3d56"
                d="M619 282.6a13.4 13.4 0 0 0 1.8-6.8c0-6.1-3.8-11.1-8.5-11.1s-8.5 5-8.5 11.1a13.3 13.3 0 0 0 1.7 6.8 13.9 13.9 0 0 0 0 13.6 13.9 13.9 0 0 0 0 13.7 13.3 13.3 0 0 0-1.7 6.8c0 6.1 3.8 11 8.5 11s8.5-5 8.5-11a13.4 13.4 0 0 0-1.8-6.8 14 14 0 0 0 0-13.7 14 14 0 0 0 0-13.6z"
              />
              <ellipse
                cx="612.3"
                cy="262.2"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <ellipse
                cx="612.3"
                cy="248.6"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#6c63ff"
                d="M580.4 155.5a39 39 0 0 1-3.1-4.7l22.3-3.6-24.1.1a40.8 40.8 0 0 1-.8-32.3L607 132l-30-22a40.8 40.8 0 1 1 67.4 45.6 41.2 41.2 0 0 1 4.6 7.4l-29 15 31-10.3a40.8 40.8 0 0 1-6.6 38.3 40.7 40.7 0 1 1-64 0 40.7 40.7 0 0 1 0-50.4z"
              />
              <path
                d="M653.2 180.7a40.6 40.6 0 0 1-8.7 25.2 40.7 40.7 0 1 1-64 0c-5.5-7 72.7-29.8 72.7-25.2z"
                opacity=".1"
              />
            </g>
            <g opacity=".1">
              <ellipse
                cx="1038.6"
                cy="322.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#3f3d56"
                d="M1029.6 258.4a18 18 0 0 1-2.4-9.1c0-8.3 5-15 11.4-15s11.4 6.7 11.4 15a18 18 0 0 1-2.4 9 18.6 18.6 0 0 1 0 18.3 18.6 18.6 0 0 1 0 18.2 18 18 0 0 1 2.4 9.1c0 8.2-5.1 14.9-11.4 14.9s-11.4-6.7-11.4-14.9a18 18 0 0 1 2.4-9.1 18.6 18.6 0 0 1 0-18.2 18.6 18.6 0 0 1 0-18.2z"
              />
              <ellipse
                cx="1038.6"
                cy="231.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <ellipse
                cx="1038.6"
                cy="212.9"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#6c63ff"
                d="M1081.2 88.2a53 53 0 0 0 4.2-6.2l-29.9-5 32.4.3a54.6 54.6 0 0 0 1-43.2l-43.4 22.5 40-29.4a54.5 54.5 0 1 0-90 61 54.5 54.5 0 0 0-6.3 10l38.9 20.2-41.4-14a54.5 54.5 0 0 0 8.8 51.3 54.5 54.5 0 1 0 85.7 0 54.5 54.5 0 0 0 0-67.4z"
              />
              <path
                d="M983.8 122a54.3 54.3 0 0 0 11.7 33.6 54.5 54.5 0 1 0 85.7 0c7.3-9.2-97.4-39.8-97.4-33.7z"
                opacity=".1"
              />
            </g>
            <g opacity=".1">
              <ellipse
                cx="928.7"
                cy="324.3"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#3f3d56"
                d="M922 276.6a13.4 13.4 0 0 1-1.8-6.8c0-6.1 3.8-11.1 8.5-11.1s8.5 5 8.5 11.1a13.3 13.3 0 0 1-1.7 6.8 13.9 13.9 0 0 1 0 13.6 13.9 13.9 0 0 1 0 13.7 13.3 13.3 0 0 1 1.7 6.8c0 6.1-3.8 11-8.5 11s-8.5-5-8.5-11a13.4 13.4 0 0 1 1.8-6.8 14 14 0 0 1 0-13.7 14 14 0 0 1 0-13.6z"
              />
              <ellipse
                cx="928.7"
                cy="256.2"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <ellipse
                cx="928.7"
                cy="242.6"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#6c63ff"
                d="M960.6 149.5a39 39 0 0 0 3.1-4.7l-22.3-3.6 24.1.1a40.8 40.8 0 0 0 .8-32.3L934 126l30-22a40.8 40.8 0 1 0-67.4 45.6 41.2 41.2 0 0 0-4.6 7.4l29 15-30.9-10.3a40.8 40.8 0 0 0 6.6 38.3 40.7 40.7 0 1 0 64 0 40.7 40.7 0 0 0 0-50.4z"
              />
              <path
                d="M887.8 174.7a40.6 40.6 0 0 0 8.7 25.2 40.7 40.7 0 1 0 64 0c5.5-7-72.7-29.8-72.7-25.2z"
                opacity=".1"
              />
            </g>
            <g opacity=".1">
              <ellipse
                cx="61.6"
                cy="322.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#3f3d56"
                d="M70.6 258.4a18 18 0 0 0 2.4-9.1c0-8.3-5.1-15-11.4-15s-11.4 6.7-11.4 15a18 18 0 0 0 2.4 9 18.7 18.7 0 0 0 0 18.3 18.7 18.7 0 0 0 0 18.2 18 18 0 0 0-2.4 9.1c0 8.2 5.1 14.9 11.4 14.9S73 312.1 73 303.9a18 18 0 0 0-2.4-9 18.6 18.6 0 0 0 0-18.3 18.6 18.6 0 0 0 0-18.2z"
              />
              <ellipse
                cx="61.6"
                cy="231.1"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <ellipse
                cx="61.6"
                cy="212.9"
                fill="#3f3d56"
                rx="11.4"
                ry="14.9"
              />
              <path
                fill="#6c63ff"
                d="M19 88.2a54.3 54.3 0 0 1-4.2-6.2l29.9-5-32.4.4a54.6 54.6 0 0 1-1-43.2l43.4 22.5-40-29.4a54.5 54.5 0 1 1 90 61 54.5 54.5 0 0 1 6.2 9.9l-38.8 20.2 41.4-14a54.6 54.6 0 0 1-8.8 51.3 54.5 54.5 0 1 1-85.7 0 54.5 54.5 0 0 1 0-67.4z"
              />
              <path
                d="M116.3 122a54.3 54.3 0 0 1-11.6 33.6 54.5 54.5 0 1 1-85.7 0c-7.3-9.2 97.3-39.8 97.3-33.7z"
                opacity=".1"
              />
            </g>
            <g opacity=".1">
              <ellipse
                cx="171.4"
                cy="324.3"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#3f3d56"
                d="M178.2 276.6a13.4 13.4 0 0 0 1.7-6.8c0-6.1-3.8-11.1-8.5-11.1s-8.5 5-8.5 11.1a13.4 13.4 0 0 0 1.8 6.8 13.9 13.9 0 0 0 0 13.6 13.9 13.9 0 0 0 0 13.7 13.4 13.4 0 0 0-1.8 6.8c0 6.1 3.8 11 8.5 11s8.5-5 8.5-11a13.4 13.4 0 0 0-1.7-6.8 14 14 0 0 0 0-13.7 14 14 0 0 0 0-13.6z"
              />
              <ellipse
                cx="171.4"
                cy="256.2"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <ellipse
                cx="171.4"
                cy="242.6"
                fill="#3f3d56"
                rx="8.5"
                ry="11.1"
              />
              <path
                fill="#6c63ff"
                d="M139.6 149.5a40.2 40.2 0 0 1-3.2-4.7l22.4-3.6-24.2.1a40.8 40.8 0 0 1-.8-32.3l32.5 16.9-30-22a40.8 40.8 0 1 1 67.3 45.6 40.1 40.1 0 0 1 4.7 7.4l-29 15 31-10.3a40.8 40.8 0 0 1-6.6 38.3 40.7 40.7 0 1 1-64 0 40.7 40.7 0 0 1 0-50.4z"
              />
              <path
                d="M212.4 174.7a40.6 40.6 0 0 1-8.8 25.2 40.7 40.7 0 1 1-64 0c-5.5-7 72.8-29.8 72.8-25.2z"
                opacity=".1"
              />
            </g>
            <ellipse
              cx="548"
              cy="493.1"
              fill="#6c63ff"
              opacity=".1"
              rx="548"
              ry="8.9"
            />
            <ellipse
              cx="548"
              cy="565.9"
              fill="#6c63ff"
              opacity=".1"
              rx="548"
              ry="8.9"
            />
            <ellipse
              cx="548"
              cy="341.3"
              fill="#6c63ff"
              opacity=".1"
              rx="548"
              ry="8.9"
            />
            <ellipse
              cx="548"
              cy="417.2"
              fill="#6c63ff"
              opacity=".1"
              rx="548"
              ry="8.9"
            />
            <path
              fill="#6c63ff"
              d="M808.8 110.4a18.3 18.3 0 0 0-10.6 1.1 15.7 15.7 0 0 1-12.8 0 17.9 17.9 0 0 0-15 .3 9.2 9.2 0 0 1-4.3 1.1c-6 0-11-6.1-12.1-14.2a11.9 11.9 0 0 0 3-3.3c3.5-5.7 9-9.4 15.2-9.4s11.7 3.7 15.2 9.3a11.7 11.7 0 0 0 10.1 5.6h.2c4.9 0 9 3.8 11 9.5z"
              opacity=".1"
            />
            <path
              fill="#6c63ff"
              d="M827.3 85l-9.8 6.2 6-10.8a9.7 9.7 0 0 0-6-2.1h-.1a11.3 11.3 0 0 1-2-.2l-3.4 2.2 1.4-2.6a11.8 11.8 0 0 1-5.8-4.5l-6 3.8 3.8-6.8a17.4 17.4 0 0 0-13.4-6.8c-6.2 0-11.7 3.7-15.3 9.5a11.4 11.4 0 0 1-10 5.4h-.4c-6.8 0-12.4 7.7-12.4 17.3s5.6 17.3 12.4 17.3a9.4 9.4 0 0 0 4.3-1 17.9 17.9 0 0 1 15-.4 15.6 15.6 0 0 0 12.8 0 18 18 0 0 1 14.8.3 9.3 9.3 0 0 0 4.3 1c6.8 0 12.4-7.7 12.4-17.2a22 22 0 0 0-2.6-10.6zM391.3 105a12.8 12.8 0 0 0-7.5.8 11 11 0 0 1-8.9 0 12.5 12.5 0 0 0-10.5.2 6.6 6.6 0 0 1-3 .7c-4.2 0-7.8-4.3-8.5-9.9a8.3 8.3 0 0 0 2.1-2.3c2.5-4 6.4-6.6 10.7-6.6s8.2 2.6 10.7 6.5a8.2 8.2 0 0 0 7 4h.1c3.4-.1 6.3 2.6 7.8 6.6z"
              opacity=".1"
            />
            <path
              fill="#6c63ff"
              d="M404.2 87.2l-6.9 4.4 4.2-7.6a6.8 6.8 0 0 0-4.1-1.5h-.2a7.5 7.5 0 0 1-1.4 0l-2.3 1.4 1-1.8a8.3 8.3 0 0 1-4-3.1l-4.3 2.6 2.7-4.8a12.2 12.2 0 0 0-9.4-4.7c-4.3 0-8.2 2.6-10.6 6.6a8 8 0 0 1-7.1 3.8h-.2c-4.8 0-8.7 5.4-8.7 12.1s3.9 12.2 8.7 12.2a6.5 6.5 0 0 0 3-.8 12.5 12.5 0 0 1 10.4-.2 11.1 11.1 0 0 0 4.5 1 11 11 0 0 0 4.5-1 12.5 12.5 0 0 1 10.4.3 6.5 6.5 0 0 0 3 .7c4.7 0 8.6-5.4 8.6-12.1a15.3 15.3 0 0 0-1.8-7.5zM269.6 183.4a12.8 12.8 0 0 1 7.4.8 11 11 0 0 0 9 0 12.5 12.5 0 0 1 10.4.2 6.5 6.5 0 0 0 3 .7c4.3 0 7.8-4.3 8.5-9.9a8.2 8.2 0 0 1-2-2.3c-2.6-4-6.4-6.6-10.8-6.6s-8.1 2.6-10.6 6.5a8.2 8.2 0 0 1-7 4h-.2c-3.4 0-6.3 2.7-7.7 6.6z"
              opacity=".1"
            />
            <path
              fill="#6c63ff"
              d="M256.6 165.7l7 4.3-4.3-7.5a6.8 6.8 0 0 1 4.2-1.5h.1a8.5 8.5 0 0 0 1.4-.1l2.4 1.4-1-1.8a8.3 8.3 0 0 0 4-3l4.2 2.6-2.6-4.8a12.2 12.2 0 0 1 9.3-4.7c4.4 0 8.2 2.5 10.7 6.6a8 8 0 0 0 7 3.8h.3c4.8 0 8.7 5.4 8.7 12s-3.9 12.2-8.7 12.2a6.5 6.5 0 0 1-3-.7 12.5 12.5 0 0 0-10.5-.3 10.9 10.9 0 0 1-4.4 1 11 11 0 0 1-4.5-.9 12.5 12.5 0 0 0-10.4.2 6.5 6.5 0 0 1-3 .7c-4.8 0-8.6-5.4-8.6-12a15.4 15.4 0 0 1 1.7-7.5z"
              opacity=".1"
            />
            <path
              fill="none"
              stroke="#3f3d56"
              strokeMiterlimit="10"
              strokeWidth="4"
              d="M664.3 490.3c2.6-4.9-.3-10.8-3.7-15.1s-7.6-8.8-7.5-14.3c.1-7.9 8.5-12.6 15.2-16.7a74.3 74.3 0 0 0 13.6-11 20.1 20.1 0 0 0 4.2-5.7c1.4-3 1.4-6.6 1.3-10q-.4-16.9-1.7-33.7"
            />
            <path
              fill="#6c63ff"
              d="M698.5 383.2a12.3 12.3 0 0 0-6.2-10l-2.8 5.4.1-6.6a12.3 12.3 0 1 0 8.9 11.2zM676.5 466.5a12.3 12.3 0 0 1-23.2-5 12 12 0 0 1 .8-5 12.3 12.3 0 0 1 23 .2l-7.7 6.2 8.4-2a12.2 12.2 0 0 1-1.3 5.6zM670.4 442.6a12.3 12.3 0 0 1-3.9-24.1v5l2.7-5.5a12.3 12.3 0 1 1 1.2 24.6zM700.3 422.8a12.3 12.3 0 1 1 5.4-23l-2.1 6 4.4-4.4a12.3 12.3 0 0 1-7.7 21.3z"
            />
            <path
              d="M696.8 386.5c-2.8.3-5.6 1.2-8.5 1.4s-6-.5-7.8-2.7a39.5 39.5 0 0 1-2.2-4 8.8 8.8 0 0 0-3.1-3 12.3 12.3 0 1 0 23 8.2l-1.4.1zM700.3 422.8a12.3 12.3 0 0 1-11.7-17.6 9.1 9.1 0 0 1 2.5 2.5 41.7 41.7 0 0 0 2.4 4c2 2.3 5.2 3 8.2 2.9s5.8-1 8.8-1.3h1.2a12.3 12.3 0 0 1-11.4 9.4zM670.4 442.6a12.3 12.3 0 0 1-11.8-17.3 10 10 0 0 1 2.6 2.5 41.2 41.2 0 0 0 2.7 4.2c2 2.3 5.6 3 8.7 3s6-.9 9-1a12.3 12.3 0 0 1-11.2 8.6zM676.5 466.5a12.3 12.3 0 0 1-23.2-5 12 12 0 0 1 .8-5 12.3 12.3 0 0 1 2.6 2.4c1.2 1.5 2 3 3.3 4.4 2.6 2.5 6.6 3.5 10.2 3.6a51.7 51.7 0 0 0 6.3-.4z"
              opacity=".1"
            />
            <path
              fill="none"
              stroke="#3f3d56"
              strokeMiterlimit="10"
              strokeWidth="4"
              d="M54.3 418.3c2.6-4.9-.3-10.8-3.7-15.1s-7.6-8.8-7.5-14.3c.1-7.9 8.5-12.6 15.2-16.7a74.3 74.3 0 0 0 13.6-11 20.1 20.1 0 0 0 4.2-5.7c1.4-3 1.4-6.6 1.3-10q-.4-16.8-1.7-33.7"
            />
            <path
              fill="#6c63ff"
              d="M88.4 311.2a12.3 12.3 0 0 0-6.1-10l-2.8 5.4.1-6.6a12.3 12.3 0 1 0 8.8 11.2zM66.5 394.5a12.3 12.3 0 0 1-23.3-5 12 12 0 0 1 .8-5 12.3 12.3 0 0 1 23 .2l-7.6 6.2 8.4-2a12.2 12.2 0 0 1-1.3 5.6zM60.4 370.6a12.3 12.3 0 0 1-3.9-24.1v5l2.7-5.5a12.3 12.3 0 1 1 1.2 24.6zM90.3 350.8a12.3 12.3 0 1 1 5.4-23l-2.1 6 4.4-4.4a12.3 12.3 0 0 1-7.7 21.3z"
            />
            <path
              d="M86.8 314.5c-2.9.3-5.6 1.2-8.5 1.4s-6-.5-7.8-2.7a39.5 39.5 0 0 1-2.2-4 8.8 8.8 0 0 0-3.1-3 12.3 12.3 0 1 0 23 8.2l-1.4.1zM90.3 350.8a12.3 12.3 0 0 1-11.7-17.6 9.1 9.1 0 0 1 2.5 2.5 41.7 41.7 0 0 0 2.4 4c2 2.3 5.2 3 8.2 2.9s5.8-1 8.8-1.3h1.2a12.3 12.3 0 0 1-11.4 9.4zM60.4 370.6a12.3 12.3 0 0 1-11.8-17.3 10 10 0 0 1 2.6 2.5A41.2 41.2 0 0 0 54 360c2 2.3 5.5 3 8.7 3s6-.9 9-1a12.3 12.3 0 0 1-11.2 8.6zM66.5 394.5a12.3 12.3 0 0 1-23.3-5 12 12 0 0 1 .8-5 12.3 12.3 0 0 1 2.7 2.4c1.2 1.5 2 3 3.3 4.4 2.6 2.5 6.6 3.5 10.2 3.6a51.7 51.7 0 0 0 6.3-.4z"
              opacity=".1"
            />
            <path
              fill="none"
              stroke="#3f3d56"
              strokeMiterlimit="10"
              strokeWidth="4"
              d="M460.5 335.9c-2.6-4.8.4-10.8 3.8-15s7.5-8.9 7.4-14.4c0-7.9-8.5-12.5-15.2-16.7a74 74 0 0 1-13.6-11 19.8 19.8 0 0 1-4.2-5.6 23 23 0 0 1-1.3-10q.5-16.9 1.7-33.8"
            />
            <path
              fill="#6c63ff"
              d="M426.4 228.9a12.3 12.3 0 0 1 6.1-10.1l2.8 5.4v-6.6a12.6 12.6 0 0 1 4-.5 12.3 12.3 0 1 1-13 11.8zM448.3 312.2a12.3 12.3 0 1 0-.6-10l7.7 6.3-8.4-2a12.2 12.2 0 0 0 1.3 5.7zM454.4 288.3a12.3 12.3 0 0 0 4-24.2v5.1l-2.8-5.5a12.3 12.3 0 0 0-12.9 11.7 12.2 12.2 0 0 0 .5 4.2 12.3 12.3 0 0 0 11.2 8.7zM424.5 268.4a12.3 12.3 0 1 0-5.4-23l2.2 6-4.5-4.3a12.2 12.2 0 0 0-4 8.5 12 12 0 0 0 .3 3.4 12.3 12.3 0 0 0 11.4 9.4z"
            />
            <path
              d="M428 232.1c2.9.3 5.7 1.2 8.5 1.4s6-.5 7.8-2.7a39.4 39.4 0 0 0 2.3-4 8.8 8.8 0 0 1 3-3 12.3 12.3 0 1 1-23 8.2l1.4.1zM424.5 268.4a12.3 12.3 0 0 0 11.8-17.6 9.2 9.2 0 0 0-2.5 2.5 41.7 41.7 0 0 1-2.5 4c-1.9 2.3-5.2 3-8.1 3s-5.9-1-8.8-1.3l-1.3-.1a12.3 12.3 0 0 0 11.4 9.5zM454.4 288.3a12.3 12.3 0 0 0 11.8-17.3 9.8 9.8 0 0 0-2.6 2.5 41.2 41.2 0 0 1-2.6 4.1c-2.1 2.3-5.6 3.1-8.8 3s-6-.8-9-1a12.3 12.3 0 0 0 11.2 8.7zM448.3 312.2a12.3 12.3 0 0 0 22.5-10 11.8 11.8 0 0 0-2.7 2.4c-1.2 1.4-2 3-3.3 4.4a15.4 15.4 0 0 1-10.2 3.5 54 54 0 0 1-6.3-.3z"
              opacity=".1"
            />
            <circle cx="779.7" cy="238.2" r="100" fill="#3f3d56" />
            <path
              fill="#6c63ff"
              d="M822.6 264a75.7 75.7 0 0 0-16-10.7c-4.8-2.3-6.5-2.3-9.9.2-2.8 2-4.7 3.9-7.9 3.2s-9.7-5.6-15.9-11.8-11-12.5-11.7-15.8 1.2-5.1 3.2-8c2.5-3.3 2.6-5 .2-9.9-2-4.1-7.1-12.5-10.7-16s-4.2-2.7-6.1-2a35.8 35.8 0 0 0-5.7 3c-3.5 2.4-5.4 4.3-6.8 7.2s-3 8.4 5 22.6a125.7 125.7 0 0 0 22.1 29.4 125.9 125.9 0 0 0 29.6 22.2c14.2 8 19.6 6.4 22.5 5s4.9-3.3 7.2-6.8a35.3 35.3 0 0 0 3-5.7c.7-1.9 1.4-2.7-2-6.1z"
            />
            <path
              d="M779.7 138.2a100 100 0 1 0 100 100 100 100 0 0 0-100-100zm0 186.7a86.7 86.7 0 1 1 86.7-86.7 86.7 86.7 0 0 1-86.7 86.7z"
              opacity=".1"
            />
            <circle cx="550.1" cy="390" r="100" fill="#3f3d56" />
            <path
              fill="#6c63ff"
              d="M607 359.8l-30 30.5a.5.5 0 0 0 0 .7l21 22.4a3.6 3.6 0 0 1-2.5 6.1 3.6 3.6 0 0 1-2.6-1L572 396.2a.6.6 0 0 0-.8 0l-5 5.2a22.4 22.4 0 0 1-16 6.7 22.9 22.9 0 0 1-16.4-7l-4.9-5a.6.6 0 0 0-.8 0l-20.8 22.3a3.6 3.6 0 0 1-5.1 0 3.6 3.6 0 0 1 0-5.1l21-22.3a.6.6 0 0 0 0-.8l-30-30.4a.6.6 0 0 0-1 .4V421a9 9 0 0 0 9 8.9H599a9 9 0 0 0 8.9-9v-60.8a.6.6 0 0 0-1-.4z"
            />
            <path
              fill="#6c63ff"
              d="M550 400.9a15.1 15.1 0 0 0 11-4.5l43.6-44.4a8.7 8.7 0 0 0-5.5-2h-98a8.6 8.6 0 0 0-5.5 2l43.6 44.4a15 15 0 0 0 10.9 4.5z"
            />
            <path
              d="M548.8 290a100 100 0 1 0 100 100 100 100 0 0 0-100-100zm0 186.7a86.7 86.7 0 1 1 86.7-86.7 86.7 86.7 0 0 1-86.7 86.7z"
              opacity=".1"
            />
            <circle cx="312.9" cy="315.4" r="100" fill="#3f3d56" />
            <path
              fill="#6c63ff"
              d="M312.9 267.5l-39.9 92 3.7 3.7 36.2-16 36.1 16 3.7-3.7z"
            />
            <path
              d="M312.9 215.4a100 100 0 1 0 99.9 100 100 100 0 0 0-100-100zm0 186.6a86.7 86.7 0 1 1 86.6-86.6A86.7 86.7 0 0 1 313 402z"
              opacity=".1"
            />
            <path
              fill="url(#a)"
              d="M841 603.9l-2.9-6.6a19.6 19.6 0 0 0-3.4-6 6.2 6.2 0 0 0-2-1.4 8.5 8.5 0 0 0-2.6-.5 20.8 20.8 0 0 0-4-.2 20 20 0 0 1-1.8-.6 14.3 14.3 0 0 0 10.6-13.2v-.6a14.3 14.3 0 0 0-14.2-14.3 14 14 0 0 0-7.4 2 13.4 13.4 0 0 0-15 7.3 16.5 16.5 0 0 0-5.1 12.3v.6c.3 7.8 5.3 14 11.6 14.7a6.7 6.7 0 0 0-1.8 1.2c-2 1.9-2.3 4.8-2.5 7.5l-.1 2-3.4 1.3a.6.6 0 0 0-.1 1l3.2 2.3V614a4.6 4.6 0 0 0-1.2 1.7 8.2 8.2 0 0 0-.3 3.3l.1 2.8a22 22 0 0 0 .9 6.2c.4 1.2 2.2 4.2 3.5 4.2-1.2 5.5-1.5 17.1-1.5 17.1-.2.2.3.3 1 .4.7 5.5 3 21 7.2 27.8a58.6 58.6 0 0 1 1.6 6.8s1.2 14.7 2.8 19a97.1 97.1 0 0 1 2.6 15.6 1.5 1.5 0 0 0-1 1.2c-.9 2.3-6 6-6 6a24.8 24.8 0 0 0-4.4 2.8c-1.6 1.4-1.5 2.8 5.6 2 13.8-1.6 16.2-6 16.2-6l-.6-1.8a18.5 18.5 0 0 0-1.8-4.2c-.2-.2-.4.1-.6.6a85.6 85.6 0 0 1-1-19.3s.4-6.8-1.6-11.5a21.8 21.8 0 0 1 0-7.6c.8-3.2-3.1-18.7-3.1-18.7l-2.3-11.4a3.3 3.3 0 0 1 .7 1.3v.6a.6.6 0 0 0 .2.3c1.6 6.4 5.8 24.1 5.8 26.7 0 3.2 4 11.2 4 11.2s1.5 13 4.3 18.2c2 4 2.1 9.7 2 12.3s-.5 3.2-1.2 4a9.7 9.7 0 0 0-1.5 2.6l-.1.2s-1.2 2.4-.4 2.8a19.4 19.4 0 0 0 9.4 1.2s1.6-2 1.6-2.8a12.5 12.5 0 0 0-.2-1.4c-.2-1.9-.8-4.8-.8-4.9.3-1.3-1-4.8-1-4.8l-.4-11.1a51.4 51.4 0 0 0-2.8-22.3s-2-7.2-1.5-9.2-.8-23-.8-23l-.1-.3a22.8 22.8 0 0 1 0-4.5c.5-4.8-1-14.7-1.5-15a13.1 13.1 0 0 1-.6-3.4l.8-6.3a113 113 0 0 0 11.6-1 1.4 1.4 0 0 0 1-.4 1.4 1.4 0 0 0 .2-.8c.5-6-1.7-11.8-4-17.3zm-8 12.6c.4-2.9.8-5.6 1.3-7.7v.2a55.6 55.6 0 0 1 2 6.3 21.4 21.4 0 0 1-3.3 1.2z"
              transform="translate(-52 -162.6)"
            />
            <path
              fill="#be6f72"
              d="M750.4 486s2.3 21.3 7.4 29.5a57.2 57.2 0 0 1 1.6 6.7s1.2 14.5 2.8 18.9 2.7 16 2.7 16 5.5 6.4 7.5 1.3a82.8 82.8 0 0 1-1.2-20.5s.4-6.7-1.6-11.4a21.3 21.3 0 0 1 0-7.4c.8-3.2-3.1-18.5-3.1-18.5l-3.2-15.3z"
            />
            <path
              fill="#ff6f61"
              d="M775.1 562.3s-2.3 4.3-16 5.9c-7.2.8-7.3-.5-5.7-2a24.9 24.9 0 0 1 4.4-2.7s5.1-3.6 6-6 3.5-.3 3.5-.3c3.9 5.9 4.7-1.6 5.5-.8a17.7 17.7 0 0 1 1.8 4.2l.5 1.7z"
            />
            <path
              d="M775.1 562.3s-2.3 4.3-16 5.9c-7.2.8-7.3-.5-5.7-2 1.2.8 3.4 1 8-.8 6.5-2.6 11.3-4.2 13.2-4.8l.5 1.7zM771.2 538s.4-6.8-1.6-11.5a21.3 21.3 0 0 1 0-7.4c.8-3.2-3.1-18.5-3.1-18.5l-3.2-15.3-2.7.1 3.1 15.2s4 15.3 3.2 18.5a21.3 21.3 0 0 0 0 7.4c2 4.7 1.6 11.4 1.6 11.4a82.8 82.8 0 0 0 1.1 20.5 3.4 3.4 0 0 1-1.1 1.6c1.5.7 3 .6 3.9-1.6a82.8 82.8 0 0 1-1.2-20.5z"
              opacity=".1"
            />
            <path
              fill="#3f3d56"
              d="M768.6 399.8a14 14 0 0 0-7.4 2.1 13.3 13.3 0 0 0-15 7.2 16.3 16.3 0 0 0-5 12.1c0 8.4 5.6 15.1 12.5 15.1 5 0 9.4-3.5 11.4-8.7a13.8 13.8 0 0 0 3.5.5 14.2 14.2 0 0 0 0-28.3z"
            />
            <path
              fill="#be6f72"
              d="M780.2 488l1.2 3.2s1.2 20.8.8 22.8 1.6 9 1.6 9a50.3 50.3 0 0 1 2.7 22l.4 11s1.6 4.3.8 5-6.7-.6-6.7-.6.8-8.3-2-13.4-4.3-18-4.3-18-4-8-4-11-6.2-28.8-6.2-28.8z"
            />
            <path
              fill="#3f3d56"
              d="M749.6 487.6s.4-14.1 2-18.4a29.3 29.3 0 0 0 1.7-6.3s23.8 4.3 25.8 2.7c0 0 .4 5.5.8 6s2 10.1 1.6 14.8 0 4.8 0 4.8-16.2 2.3-16.6 0-1.5-2.4-1.5-2.4-14.6-.4-13.8-1.2z"
            />
            <g opacity=".1">
              <path d="M762.5 487.6s-9.9-.2-12.9-.8v.8c-.8.8 13.8 1.2 13.8 1.2a1 1 0 0 1 .5.2c-.5-1.4-1.4-1.4-1.4-1.4zM779.9 471.5c-.4-.4-.8-5.9-.8-5.9a1.7 1.7 0 0 1-.7.3c.1 1.6.4 4.2.7 4.4s2 10.3 1.5 15 0 4.7 0 4.7-12.7 1.9-15.8.6l.1.6c.4 2.3 16.5 0 16.5 0s-.4 0 0-4.7-1.2-14.6-1.5-15z" />
              <path
                fill="url(#b)"
                d="M814.5 650.3s-9.9-.3-12.9-.8v.8c-.8.7 13.8 1.1 13.8 1.1a1 1 0 0 1 .5.3c-.5-1.4-1.4-1.4-1.4-1.4zM831.9 634.1c-.4-.4-.8-5.9-.8-5.9a1.7 1.7 0 0 1-.7.3c.1 1.7.4 4.2.7 4.5s2 10.2 1.5 14.9 0 4.7 0 4.7-12.7 1.9-15.8.6l.1.6c.4 2.4 16.5 0 16.5 0s-.4 0 0-4.7-1.2-14.6-1.5-15z"
                transform="translate(-52 -162.6)"
              />
            </g>
            <path
              fill="#be6f72"
              d="M766.9 424.5a5.2 5.2 0 0 0 1.5 2 3.4 3.4 0 0 0 1.4.6l-2.7 1.4a48.4 48.4 0 0 0-4 3 8.1 8.1 0 0 1-4.6 1.8 5.6 5.6 0 0 0 .6-5.6 5.2 5.2 0 0 1-.7-2c0-1 1-2 2-2.6l2.3-1.4c.6-.4 1.5-1.2 2.3-1.2s.8.7 1 1.4a11 11 0 0 0 .9 2.7z"
            />
            <path
              d="M766.9 424.5a5.2 5.2 0 0 0 1.5 2 3.4 3.4 0 0 0 1.4.6l-2.7 1.4a48.4 48.4 0 0 0-4 3 8.1 8.1 0 0 1-4.6 1.8 5.6 5.6 0 0 0 .6-5.6 5.2 5.2 0 0 1-.7-2c0-1 1-2 2-2.6l2.3-1.4c.6-.4 1.5-1.2 2.3-1.2s.8.7 1 1.4a11 11 0 0 0 .9 2.7z"
              opacity=".1"
            />
            <circle cx="776.1" cy="438.7" r="9" fill="#be6f72" />
            <path
              fill="#ff6f61"
              d="M788.9 567c0 .8-1.6 2.8-1.6 2.8a19.5 19.5 0 0 1-9.4-1.2c-.8-.4.4-2.8.4-2.8v-.2a9.5 9.5 0 0 1 1.6-2.5c.7-.8 1.2-4 1.2-4 2.4-4 6.8 1.7 6.8 1.7a274.2 274.2 0 0 0 1 6.2z"
            />
            <path
              d="M788.9 567c0 .8-1.6 2.8-1.6 2.8a19.5 19.5 0 0 1-9.4-1.2c-.8-.4.4-2.8.4-2.8v-.2a19 19 0 0 0 8.6 1.8l1.8-1.8.2 1.4z"
              opacity=".1"
            />
            <circle cx="758" cy="419.8" r="8.8" fill="#be6f72" />
            <path
              fill="#be6f72"
              d="M750.9 437.5c-2 1.9-2.3 4.8-2.5 7.5l-.3 3.9a19.7 19.7 0 0 0 0 3.1l.2 2v8.2a6.8 6.8 0 0 0 .7 3.4 2.4 2.4 0 0 0 3 1.1 3.4 3.4 0 0 0 1.3-1.9 29.9 29.9 0 0 0 2-7.3l.1-2.6.4-2.7c.6-3.7.8-7.4 1-11.1.1-1.1 1.1-5.4-.3-6-.7-.1-2.2.6-2.9.8a8 8 0 0 0-2.7 1.6z"
            />
            <path
              d="M750.9 437.5c-2 1.9-2.3 4.8-2.5 7.5l-.3 3.9a19.7 19.7 0 0 0 0 3.1l.2 2v8.2a6.8 6.8 0 0 0 .7 3.4 2.4 2.4 0 0 0 3 1.1 3.4 3.4 0 0 0 1.3-1.9 29.9 29.9 0 0 0 2-7.3l.1-2.6.4-2.7c.6-3.7.8-7.4 1-11.1.1-1.1 1.1-5.4-.3-6-.7-.1-2.2.6-2.9.8a8 8 0 0 0-2.7 1.6z"
              opacity=".1"
            />
            <path
              fill="#ff6f61"
              d="M769.2 425.5s-6.7 5.1-10.6 6.3l-2.7 3.3c-.4.6-1.2 7.7-2 9.3s-2.8 5.1 0 8.6c0 0 .8 3.6.4 4.8s-1.8 5.5-.5 5.7 5.2 2.9 8.7 2.1 16.7 3 16.7 3 2.2-20.2 3.8-23.8l-3.5-1.2s-9.9-5.9-4-15c0 0-5.5-1.1-6.3-3z"
            />
            <path
              fill="#3f3d56"
              d="M744.8 449.2l8.2 5.8a.6.6 0 0 0 .7 0l2.2-1.7a.6.6 0 0 0 0-1l-6.3-5.5a.6.6 0 0 0-.6-.1l-4 1.4a.6.6 0 0 0-.2 1.1z"
            />
            <path
              fill="#be6f72"
              d="M747.6 466.5a21.8 21.8 0 0 1-.9-6.1l-.1-2.8a8 8 0 0 1 .3-3.2 5.2 5.2 0 0 1 3.4-3 11.6 11.6 0 0 1 4.6-.3 1.2 1.2 0 0 1 .5.2 1.1 1.1 0 0 1 .4.5 3.6 3.6 0 0 1 .1 3 3 3 0 0 1-.9.9c-1 .8-2.3 1.3-3.4 2.1a1.2 1.2 0 0 0-.4.6 1.4 1.4 0 0 0 0 .6 10 10 0 0 0 .5 1.7 1.6 1.6 0 0 0 .4.6l.7.4c.4.4 1.3.8 1.3 1.4-.2 2-1.4 4.2-1.9 6.2-.9 3.9-4-1-4.6-2.8z"
            />
            <g opacity=".1">
              <path d="M760.2 465.6h-.2a6.7 6.7 0 0 0 2.6 0h.2a9 9 0 0 0-2.6 0zM780.8 444.2c-1.4 3.2-3.5 20.3-3.8 23.8l2.3.6s2.1-20.2 3.7-23.8z" />
            </g>
            <path
              fill="#be6f72"
              d="M776.4 439a3 3 0 0 0 1.3 2 17.3 17.3 0 0 1 2.3 2.3 16.4 16.4 0 0 1 2.3 4.5 55.8 55.8 0 0 1 1.9 6.2c-5 2.3-10.7 2.2-16 3.8a12.8 12.8 0 0 0-6 3.5 8.3 8.3 0 0 0-2.3 6.5.8.8 0 0 0 .2.4.8.8 0 0 0 .7.3 6 6 0 0 0 3.6-1.3 17.5 17.5 0 0 0 2.8-2.7 4.5 4.5 0 0 1 2-1.5c3-.9 6-.8 9-.9a113.4 113.4 0 0 0 13.5-1 1 1 0 0 0 1.2-1.3c.4-5.8-1.8-11.6-4-17l-2.8-6.6a19.4 19.4 0 0 0-3.4-5.8 6 6 0 0 0-2-1.5 8.5 8.5 0 0 0-2.7-.5 19 19 0 0 0-4.4-.1 9.4 9.4 0 0 0-.4 2.3c0 2.7 1.3 5.2 2.4 7.6.2.4.6.4.8.8z"
            />
            <path
              fill="none"
              stroke="#000"
              strokeMiterlimit="10"
              d="M760.4 444a7.3 7.3 0 0 0-1 3.9 5.1 5.1 0 0 0 .3 1.5 5 5 0 0 0 3.1 3"
              opacity=".1"
            />
            <path
              fill="#3f3d56"
              d="M765.5 411.2a4.6 4.6 0 0 0-1.4.2c-1.4-2-4.4-3.4-8-3.4-4.8 0-8.7 2.5-8.7 5.6s3.9 5.5 8.7 5.5a12.2 12.2 0 0 0 5.1-1.1 4.7 4.7 0 1 0 4.3-6.8z"
            />
            <path
              d="M765.9 419.4a4.7 4.7 0 0 1-4.2-2.6 12.2 12.2 0 0 1-5.2 1c-4.8 0-8.7-2.4-8.7-5.4a3.3 3.3 0 0 1 0-.6 3.7 3.7 0 0 0-.4 1.8c0 3 3.8 5.5 8.6 5.5a12.2 12.2 0 0 0 5.2-1.1 4.7 4.7 0 0 0 8.9-1.2 4.7 4.7 0 0 1-4.2 2.6z"
              opacity=".1"
            />
            <path
              d="M746.2 411.4a13.3 13.3 0 0 1 15-7.2 14.1 14.1 0 0 1 21.5 10.9v-1.2a14.1 14.1 0 0 0-21.5-12 13.3 13.3 0 0 0-15 7.2 16.3 16.3 0 0 0-5.1 12.1v1.2a16 16 0 0 1 5.1-11z"
              opacity=".1"
            />
            <path
              fill="none"
              stroke="#3f3d56"
              strokeMiterlimit="10"
              strokeWidth="4"
              d="M836.4 414.4c2.6-4.9-.4-10.8-3.8-15.1s-7.5-8.8-7.4-14.3c0-7.9 8.5-12.5 15.2-16.7a73.9 73.9 0 0 0 13.6-11 20 20 0 0 0 4.2-5.6 23 23 0 0 0 1.3-10q-.5-17-1.7-33.8"
            />
            <path
              fill="#6c63ff"
              d="M870.5 307.3a12.3 12.3 0 0 0-6.1-10l-2.8 5.4.1-6.6a12 12 0 0 0-4-.5 12.3 12.3 0 1 0 12.8 11.7zM848.6 390.6a12.3 12.3 0 1 1 .6-9.9l-7.7 6.3 8.4-2a12.2 12.2 0 0 1-1.3 5.6zM842.5 366.7a12.3 12.3 0 0 1-4-24.1v5l2.8-5.5a12.3 12.3 0 0 1 12.9 11.8 12.3 12.3 0 0 1-11.7 12.8zM872.4 346.8a12.3 12.3 0 1 1 5.4-23l-2.2 6 4.5-4.3a12.2 12.2 0 0 1 4 8.5 11.9 11.9 0 0 1-.3 3.4 12.3 12.3 0 0 1-11.4 9.4z"
            />
            <path
              d="M868.9 310.6c-2.9.3-5.6 1.2-8.5 1.4s-6-.6-7.8-2.8a38.2 38.2 0 0 1-2.3-4 8.8 8.8 0 0 0-3-2.9 12.3 12.3 0 1 0 23 8.2h-1.4zM872.4 346.8a12.3 12.3 0 0 1-11.7-17.5 9.1 9.1 0 0 1 2.4 2.5 39.5 39.5 0 0 0 2.5 4c1.9 2.3 5.2 3 8.1 2.9s5.9-1 8.8-1.3h1.3a12.3 12.3 0 0 1-11.4 9.4zM842.5 366.7a12.3 12.3 0 0 1-11.8-17.3 10.2 10.2 0 0 1 2.6 2.5c1 1.3 1.5 2.9 2.7 4.1 2 2.3 5.5 3.1 8.7 3s6-.7 9-1a12.3 12.3 0 0 1-11.2 8.7zM848.6 390.6a12.3 12.3 0 0 1-22.5-10 12 12 0 0 1 2.7 2.4c1.2 1.5 2 3 3.3 4.4 2.5 2.5 6.6 3.5 10.2 3.6a54 54 0 0 0 6.3-.4z"
              opacity=".1"
            />
            <path
              fill="none"
              stroke="#3f3d56"
              strokeMiterlimit="10"
              strokeWidth="4"
              d="M995.4 566.4c2.6-4.9-.4-10.8-3.8-15.1s-7.5-8.8-7.4-14.3c0-7.9 8.5-12.5 15.2-16.7a73.9 73.9 0 0 0 13.6-11 20 20 0 0 0 4.2-5.6 23 23 0 0 0 1.3-10q-.5-17-1.7-33.8"
            />
            <path
              fill="#6c63ff"
              d="M1029.5 459.3a12.3 12.3 0 0 0-6.1-10l-2.8 5.4.1-6.6a12 12 0 0 0-4-.5 12.3 12.3 0 1 0 12.9 11.7zM1007.6 542.6a12.3 12.3 0 1 1 .6-9.9l-7.7 6.3 8.4-2a12.2 12.2 0 0 1-1.3 5.6zM1001.5 518.7a12.3 12.3 0 0 1-4-24.1v5l2.8-5.5a12.3 12.3 0 0 1 12.9 11.8 12.3 12.3 0 0 1-11.7 12.8zM1031.4 498.8a12.3 12.3 0 1 1 5.4-23l-2.2 6 4.5-4.3a12.2 12.2 0 0 1 4 8.5 11.9 11.9 0 0 1-.3 3.4 12.3 12.3 0 0 1-11.4 9.4z"
            />
            <path
              d="M1027.9 462.6c-2.9.3-5.6 1.2-8.5 1.4s-6-.5-7.8-2.8a38.2 38.2 0 0 1-2.3-4 8.8 8.8 0 0 0-3-2.9 12.3 12.3 0 1 0 23 8.2h-1.4zM1031.4 498.8a12.3 12.3 0 0 1-11.7-17.5 9.1 9.1 0 0 1 2.4 2.5 39.5 39.5 0 0 0 2.5 4c1.9 2.3 5.2 3 8.1 2.9s5.9-1 8.8-1.3h1.3a12.3 12.3 0 0 1-11.4 9.4zM1001.5 518.7a12.3 12.3 0 0 1-11.8-17.3 10.2 10.2 0 0 1 2.6 2.5c1 1.3 1.5 2.9 2.7 4.1 2 2.3 5.5 3.1 8.7 3s6-.7 9-1a12.3 12.3 0 0 1-11.2 8.7zM1007.6 542.6a12.3 12.3 0 0 1-22.5-10 12 12 0 0 1 2.7 2.4c1.2 1.5 2 3 3.3 4.4 2.5 2.5 6.6 3.5 10.2 3.6a54 54 0 0 0 6.3-.4z"
              opacity=".1"
            />
            <path
              fill="url(#c)"
              d="M530 588a9.8 9.8 0 0 0-4-8 11.5 11.5 0 0 0-9.5-11.3 11.5 11.5 0 0 0-7.7-8.5 9.8 9.8 0 0 0-1.4-.4H505.7a11.3 11.3 0 0 0-10.9 9.7c-3.5-.9-6.7.2-7.3 2.4a3 3 0 0 0 .1 1.8c.6 1.7 2.6 3.4 5.2 4.2h.3l.5.2h.2a8.8 8.8 0 0 0-.9 3.8 8.7 8.7 0 0 0 4.7 7.8l-.2.1a3.1 3.1 0 0 0-.8 1 15.9 15.9 0 0 0-1.4 3.6c-.3 1-.3 2.2-.6 3.2-.6 2-2.1 3.6-2.3 5.6 0 1 .1 2-.5 2.6a3.1 3.1 0 0 1-.6.4 4.1 4.1 0 0 0-1 1.1 3.9 3.9 0 0 1-.8 1.1c-.6.5-1.6.4-1.8 1.1s.4 1.5.2 2.2-.8.9-1.2 1.3a4.5 4.5 0 0 0-1 2 6.6 6.6 0 0 1-5.5-1.4 10 10 0 0 1 .6 2 8.8 8.8 0 0 0-3-1.5 9.2 9.2 0 0 1-3-2.3l1.6-.2-7.3-11.2-2.2-.4 2 3.7a1.2 1.2 0 0 0-.7.8 3.4 3.4 0 0 0 0 1.2 22.7 22.7 0 0 0 .4 3l.6 2.7.2.7a6.9 6.9 0 0 0-2.2.2 18.9 18.9 0 0 0-4.5-1 2.5 2.5 0 0 0-1 0 2.6 2.6 0 0 0-1 .7 30.8 30.8 0 0 0-3.3 4.8c-4 6.8-9.2 12.8-14.1 19l-10.3 4-7.4 2.8a11.2 11.2 0 0 1-4.6 1c-.7 0-1.5-.1-2 .5a4.2 4.2 0 0 0-.4 1h-.8a8.7 8.7 0 0 0-1.7-3.2 1.1 1.1 0 0 0-.9.6l-.5 1c-.4.6-1 .9-1.5 1.4s-.8 1.2-1.4 1.7a5.3 5.3 0 0 1-2.5 1 15.8 15.8 0 0 0-4 1.5 6.3 6.3 0 0 1-1.4.7 5.5 5.5 0 0 1-1.7 0l-3.9-.2a3 3 0 0 0-1 0 2 2 0 0 0-1.3 2 3.1 3.1 0 0 0 1.3 2.2 8 8 0 0 0 2.2 1.1 65.2 65.2 0 0 0 10.4 3.1v.8a17.8 17.8 0 0 0 8 1.9 1.2 1.2 0 0 0 .6-.1 1.3 1.3 0 0 0 .5-.8 32.2 32.2 0 0 0 1.6-7.7 4 4 0 0 0 1.4-.3c1.3-.4 2.6.5 4 .7 1.7.2 3.3-.8 5-1.4l.6-.3a7.7 7.7 0 0 1-1.6 1.6l-2 1.3a14.3 14.3 0 0 1-1.8 1.4 11 11 0 0 1-1.4.5 9 9 0 0 0-1.9 1 4 4 0 0 0-1.3 1.3 2 2 0 0 0-.1 1.8 1.9 1.9 0 0 0 1.3.9 5.3 5.3 0 0 0 1.6 0l6.3-.6a17 17 0 0 0 2.7-.3l1.3-.4a12.3 12.3 0 0 1 2.4-.4 2 2 0 0 1 .8 0c.4.2.8.7 1.3.8a2 2 0 0 0 1 0 22.3 22.3 0 0 1 4.7-.6c.7 0 1.5-.2 1.8-.8s-.3-1.7-.5-2.5a7.7 7.7 0 0 1-.2-1.7 10.4 10.4 0 0 0-1.2-4 10.3 10.3 0 0 1-.9-1.7 45.5 45.5 0 0 0 8.7-4.4 15.4 15.4 0 0 1 4.9-2.4 13.4 13.4 0 0 1 6.2.8 140.6 140.6 0 0 1 14.1 4.9c2.2.9 4.4 1.9 6.7 2.6a10.4 10.4 0 0 0 2.4 2.3 11 11 0 0 0 5.1 1.4 67.5 67.5 0 0 0 7.3.2 12.2 12.2 0 0 0 5.4-1 5.5 5.5 0 0 0 1.1-.7 4.5 4.5 0 0 0 3.6-1.3 8.6 8.6 0 0 0 2.7-4.3c.6-2.3.1-5 1.5-6.8l1.3-1.4a4 4 0 0 0 .6-2.3.5.5 0 0 1 0-.1 8.5 8.5 0 0 0 .7-2.3 13.1 13.1 0 0 1 .6-1.8 56.2 56.2 0 0 0 1.9-5.4 31.5 31.5 0 0 0 .8-3.7l.4-3a18.6 18.6 0 0 1 .9-4.7 37.7 37.7 0 0 0 2-11v-.3a7.4 7.4 0 0 0 6.6-7.5 7.9 7.9 0 0 0-.6-3.3 10 10 0 0 0 1.3-5zm-35.8 43.4l.4 1.1-1.8-1.7.7.2a3.7 3.7 0 0 1 .7.4zm-2.8-2c-3.5-3-7.5-5.3-11-8.2l5.7 3.1q3.3 2 6.7 3.7a5.5 5.5 0 0 1-1.4 1.5zm1.5-7.5l.1-.2v1.2l-.9-.3a8.3 8.3 0 0 0 .7-.7zm-30.5 8.1a28.6 28.6 0 0 0 3.7-5.3c1.4 2.4 3.6 4.2 5.5 6.2-3-.4-6.1-.7-9.2-.9z"
              transform="translate(-52 -162.6)"
            />
            <path
              fill="#2f2e41"
              d="M415.4 438.3l2.1.4 7.5 11-3.3.4-6.3-11.8z"
            />
            <path
              fill="#fbbebe"
              d="M362.5 482.8a42.8 42.8 0 0 0 2.2 5.7 54 54 0 0 0 7.2-2 22.9 22.9 0 0 0-1.5-2 7.5 7.5 0 0 0-2-1.6 5.6 5.6 0 0 0-2.5 0h-3.4z"
            />
            <path
              fill="#2f2e41"
              d="M368.4 485.8a4.5 4.5 0 0 1-2.5-2.9 9 9 0 0 0-1.9-3.3 1 1 0 0 0-.8.6l-.5 1c-.4.6-1.1.9-1.6 1.3s-.8 1.3-1.4 1.8a5.3 5.3 0 0 1-2.5 1 16.4 16.4 0 0 0-4 1.4 6.9 6.9 0 0 1-1.5.7 5.8 5.8 0 0 1-1.7 0l-4-.3a3 3 0 0 0-1 0 2 2 0 0 0-1.2 2 3 3 0 0 0 1.3 2.1 8.3 8.3 0 0 0 2.2 1.2 65.9 65.9 0 0 0 10.6 3v.7a18.3 18.3 0 0 0 8 2 1.4 1.4 0 0 0 .6-.2 1.3 1.3 0 0 0 .5-.8 31.2 31.2 0 0 0 1.7-8.5 6.8 6.8 0 0 0-.2-2.2c-.2-.7.5-.4-.2-.7"
            />
            <path
              fill="#2f2e41"
              d="M444 471c-11.7.6-23.3-2.8-35-3.2a17 17 0 0 0-4.3.3 21.9 21.9 0 0 0-4.3 1.7c-6.3 2.9-12.8 5.3-19.3 7.7l-7.4 2.8a11.3 11.3 0 0 1-4.6 1c-.7 0-1.6-.2-2 .4-1.2 1.8-.7 4.5.1 6.5.3.6.7 1.3 1.4 1.4a4 4 0 0 0 1.4-.4c1.4-.3 2.8.6 4.2.7 1.7.2 3.3-.8 4.9-1.4 2.7-1 5.6-1 8.5-1.4a38 38 0 0 0 13.3-5.5 15.5 15.5 0 0 1 5-2.3 13.7 13.7 0 0 1 6.1.7 143 143 0 0 1 14.3 4.8 66.6 66.6 0 0 0 7.5 2.8 27 27 0 0 0 16.7-1c1.9-.8 4-2 4-4.1 0-1.1-.8-2.2-1.4-3.1l-1.2-2c-2-2.8-4.4-6.7-8-6.5z"
            />
            <path
              d="M444 471c-11.7.6-23.3-2.8-35-3.2a17 17 0 0 0-4.3.3 21.9 21.9 0 0 0-4.3 1.7c-6.3 2.9-12.8 5.3-19.3 7.7l-7.4 2.8a11.3 11.3 0 0 1-4.6 1c-.7 0-1.6-.2-2 .4-1.2 1.8-.7 4.5.1 6.5.3.6.7 1.3 1.4 1.4a4 4 0 0 0 1.4-.4c1.4-.3 2.8.6 4.2.7 1.7.2 3.3-.8 4.9-1.4 2.7-1 5.6-1 8.5-1.4a38 38 0 0 0 13.3-5.5 15.5 15.5 0 0 1 5-2.3 13.7 13.7 0 0 1 6.1.7 143 143 0 0 1 14.3 4.8 66.6 66.6 0 0 0 7.5 2.8 27 27 0 0 0 16.7-1c1.9-.8 4-2 4-4.1 0-1.1-.8-2.2-1.4-3.1l-1.2-2c-2-2.8-4.4-6.7-8-6.5z"
              opacity=".1"
            />
            <path
              fill="#fbbebe"
              d="M385 483.4l5.5 1.7c1-1.7 3-3 3.4-4.9a.5.5 0 0 0 0-.2.5.5 0 0 0-.2-.2 10.5 10.5 0 0 0-4.4-1.3c-1.2 0-1.7 1.2-2.3 2-.2.5-1.6 3-2 2.9z"
            />
            <path
              fill="#2f2e41"
              d="M387.5 482.1a4 4 0 0 1-2.7-1.7c-.3-.5-.5-1-1-1s-.8.6-.9 1a30 30 0 0 1-1.5 5.2 9.7 9.7 0 0 1-3.2 4.3l-2.1 1.3a14.4 14.4 0 0 1-1.8 1.3 10.5 10.5 0 0 1-1.3.5 9.4 9.4 0 0 0-2 1 3.9 3.9 0 0 0-1.3 1.3 1.8 1.8 0 0 0-.1 1.8 1.9 1.9 0 0 0 1.3.9 5.4 5.4 0 0 0 1.6 0l6.4-.6a18.4 18.4 0 0 0 2.7-.3l1.3-.4a11 11 0 0 1 2.5-.4 1.9 1.9 0 0 1 .7.1c.5.2.8.6 1.3.7a2.3 2.3 0 0 0 1 0 22 22 0 0 1 4.8-.6c.7 0 1.5-.2 1.8-.8.4-.8-.3-1.6-.5-2.5a8 8 0 0 1-.2-1.6 10 10 0 0 0-1.2-3.9c-.6-1-1.3-2-1-3.1a3 3 0 0 0 .4-1.1c-.1-1.7-4-1.1-5-1.4z"
            />
            <path
              fill="#fbbebe"
              d="M426.4 452.2a9.1 9.1 0 0 1-4.6-4.7l-.6-1.3a10.3 10.3 0 0 0-2.8-3.9 1.4 1.4 0 0 0-1-.4 1 1 0 0 0-.7.8 3 3 0 0 0 0 1.3 22.3 22.3 0 0 0 .4 2.9l.6 2.6a5.7 5.7 0 0 0 .3 1.1 4 4 0 0 0 1 1.1l1.6 1.4a5.4 5.4 0 0 0 1 .7 5.8 5.8 0 0 0 1.7.5 15 15 0 0 1 6.7 2.6v-2a2.5 2.5 0 0 0-.5-1.3 8.9 8.9 0 0 0-3-1.4z"
            />
            <path
              d="M426.4 452.2a9.1 9.1 0 0 1-4.6-4.7l-.6-1.3a10.3 10.3 0 0 0-2.8-3.9 1.4 1.4 0 0 0-1-.4 1 1 0 0 0-.7.8 3 3 0 0 0 0 1.3 22.3 22.3 0 0 0 .4 2.9l.6 2.6a5.7 5.7 0 0 0 .3 1.1 4 4 0 0 0 1 1.1l1.6 1.4a5.4 5.4 0 0 0 1 .7 5.8 5.8 0 0 0 1.7.5 15 15 0 0 1 6.7 2.6v-2a2.5 2.5 0 0 0-.5-1.3 8.9 8.9 0 0 0-3-1.4z"
              opacity=".1"
            />
            <ellipse cx="450.2" cy="429.6" fill="#2f2e41" rx="2.8" ry="2.9" />
            <path
              fill="#2f2e41"
              d="M448.4 427.9a3 3 0 0 0-2.2.3 3.1 3.1 0 0 0-.8 1 15.3 15.3 0 0 0-1.4 3.5c-.3 1-.3 2.1-.7 3.2-.5 1.9-2 3.5-2.2 5.5 0 .8 0 1.9-.6 2.5a3.7 3.7 0 0 1-.5.4 3.8 3.8 0 0 0-1.1 1.1 3.8 3.8 0 0 1-.8 1c-.6.5-1.5.5-1.8 1s.4 1.5.3 2.3-.8.8-1.3 1.2a4.4 4.4 0 0 0-1 2 6.7 6.7 0 0 1-5.5-1.3 17.3 17.3 0 0 1 .8 6.2 2.5 2.5 0 0 1-.5 1.9 34.6 34.6 0 0 1 6.7 1.2 4.6 4.6 0 0 0 3 0 4.9 4.9 0 0 0 1.3-1.1c1.2-1.2 2.4-2.5 2.7-4.2a25 25 0 0 0 0-3 16.2 16.2 0 0 1 .8-3.4 41.5 41.5 0 0 0 1.3-7.2c0-1.5 1.4-2.7 2-4 1.4-2.5 2.7-5.1 2.8-8 0-.9-.3-2-1.3-2.1z"
            />
            <path
              d="M448.4 427.9a3 3 0 0 0-2.2.3 3.1 3.1 0 0 0-.8 1 15.3 15.3 0 0 0-1.4 3.5c-.3 1-.3 2.1-.7 3.2-.5 1.9-2 3.5-2.2 5.5 0 .8 0 1.9-.6 2.5a3.7 3.7 0 0 1-.5.4 3.8 3.8 0 0 0-1.1 1.1 3.8 3.8 0 0 1-.8 1c-.6.5-1.5.5-1.8 1s.4 1.5.3 2.3-.8.8-1.3 1.2a4.4 4.4 0 0 0-1 2 6.7 6.7 0 0 1-5.5-1.3 17.3 17.3 0 0 1 .8 6.2 2.5 2.5 0 0 1-.5 1.9 34.6 34.6 0 0 1 6.7 1.2 4.6 4.6 0 0 0 3 0 4.9 4.9 0 0 0 1.3-1.1c1.2-1.2 2.4-2.5 2.7-4.2a25 25 0 0 0 0-3 16.2 16.2 0 0 1 .8-3.4 41.5 41.5 0 0 0 1.3-7.2c0-1.5 1.4-2.7 2-4 1.4-2.5 2.7-5.1 2.8-8 0-.9-.3-2-1.3-2.1z"
              opacity=".1"
            />
            <path
              fill="#2f2e41"
              d="M445.8 473.4c-2.5-1.2-4.2-3.3-6.2-5.2-3.8-3.5-8.3-6-12.3-9.3-2.6-2.2-5-4.8-7.8-6.6a19.6 19.6 0 0 0-8.4-3 2.2 2.2 0 0 0-1 0 2.3 2.3 0 0 0-1 .8 30.2 30.2 0 0 0-3.4 4.7c-5 8.5-12 15.6-18 23.5a1.5 1.5 0 0 0-.2.6 1.4 1.4 0 0 0 .2.8l1.2 2.4c.7 1.3 1.7 2.8 3.2 2.6a3.5 3.5 0 0 0 1.6-1.1l5.4-5.2 5.7-5.3c3.3-3.2 6.6-6.4 8.8-10.5 1.7 3 4.6 4.9 6.7 7.5.8 1 1.4 2.2 2.1 3.2 1.1 1.8 2.4 3.4 3.6 5l6.5 8.3a12.4 12.4 0 0 0 3 3 11.4 11.4 0 0 0 5.2 1.4 68.6 68.6 0 0 0 7.3.2 12.6 12.6 0 0 0 5.5-1 5 5 0 0 0 3-4.3 6.4 6.4 0 0 0-1-2.8 22.3 22.3 0 0 0-9.7-9.7z"
            />
            <ellipse cx="451.9" cy="431.6" fill="#e8e8f0" rx="2.2" ry="2.2" />
            <path
              fill="#fbbebe"
              d="M451.5 429.9a4.2 4.2 0 0 1 .2 3.2 12.8 12.8 0 0 1-1.4 2.9 13.8 13.8 0 0 1-1.8 2.6c3.4.1 6.6-1.2 9.6-2.8a14 14 0 0 0 6-5.3 2.8 2.8 0 0 1-2.2-.4 8 8 0 0 1-1.7-1.6l-1.7-1.9a7.6 7.6 0 0 1-1-1.4 3.8 3.8 0 0 1-.4-2.2 12.9 12.9 0 0 1-2.3 1.9c-1.2.8-2.5 1.4-3.7 2.1-.4.3-1.4.8-1.2 1.3s1.2 1 1.6 1.6z"
            />
            <path
              d="M451.5 429.9a4.2 4.2 0 0 1 .2 3.2 12.8 12.8 0 0 1-1.4 2.9 13.8 13.8 0 0 1-1.8 2.6c3.4.1 6.6-1.2 9.6-2.8a14 14 0 0 0 6-5.3 2.8 2.8 0 0 1-2.2-.4 8 8 0 0 1-1.7-1.6l-1.7-1.9a7.6 7.6 0 0 1-1-1.4 3.8 3.8 0 0 1-.4-2.2 12.9 12.9 0 0 1-2.3 1.9c-1.2.8-2.5 1.4-3.7 2.1-.4.3-1.4.8-1.2 1.3s1.2 1 1.6 1.6z"
              opacity=".1"
            />
            <path
              fill="#e8e8f0"
              d="M451.5 430.2a2.9 2.9 0 0 0 0 3.3l.6 1a.6.6 0 0 0 .4-.3 25.1 25.1 0 0 0 2.1-2.5 4.8 4.8 0 0 1 2.8-1.8 5.9 5.9 0 0 1 3.7 1.2 3.6 3.6 0 0 1 1.3 1 3.5 3.5 0 0 1 .4 1.4 68.9 68.9 0 0 1 .4 9 35.8 35.8 0 0 1-.4 6.6c-.2 1.1-.6 2.2-.7 3.4a21.2 21.2 0 0 0-.2 3v4.1a11 11 0 0 0 .2 2.3c.2 1 .6 1.8 1 2.7a17.3 17.3 0 0 1 .5 3.1l.6 4.3c.2 1.4.3 2.9-.5 4l-1.2 1.4c-1.5 1.8-1 4.5-1.6 6.7a8.4 8.4 0 0 1-2.7 4.2 4.5 4.5 0 0 1-3.6 1.3c-1.8-.3-2.9-2.1-3.3-3.9s-.7-3.6-1.7-5a13.4 13.4 0 0 0-3.4-2.8 5.8 5.8 0 0 1-2.6-3.4v-2a4.5 4.5 0 0 0-2.9-3.6c-.9-.4-2-.5-2.5-1.3a6 6 0 0 0 2.6-3.5 18.1 18.1 0 0 0 .7-4.5l.3-5c.1-2.3.2-4.5 1.2-6.5l1.4-2.6a28.7 28.7 0 0 0 1.6-4l2-6.1a11.7 11.7 0 0 1 1.2-2.9c.5-1 1.3-2 2.3-2.3z"
            />
            <path
              fill="#2f2e41"
              d="M440.4 462.9h1.3l.3-2a4.2 4.2 0 0 1 .2-1.2 7 7 0 0 1 .8-1.1c1.3-1.9 1.2-4.3 1.5-6.6a33.3 33.3 0 0 1 3-8.5l2.5-5.8a8 8 0 0 0 .6-1.5 8.8 8.8 0 0 0 .2-1.7l.3-5c0-.3-.8-.1-.9-.4-.3-.6-.8 1.1-1.4 1.5a3.4 3.4 0 0 0-1.2 1.7l-1.4 4.4a9 9 0 0 1-2.4 4l-1.6 1.3c-1.6 1.6-1.8 4-1.8 6.3 0 1.4-.3 14.6 0 14.6zM459.5 427.8a4.5 4.5 0 0 0-2.4 3.3 16.4 16.4 0 0 1-1.2 4c-1.6 2.8-5.7 3.6-6.9 6.7a12.3 12.3 0 0 0-.4 3.1c-.2 2.2-1 4.3-1.2 6.5a28.9 28.9 0 0 0 .2 5.1l1.4 17.2a23 23 0 0 1-.4 7.6 7.3 7.3 0 0 0 4.3-.7c1.4-.6 2.6-1.5 4-2.2 2.1-1.3 4.6-2.1 6.6-3.8a4 4 0 0 0 .9-1 8.7 8.7 0 0 0 .6-2.2 12.2 12.2 0 0 1 .6-1.8 52.5 52.5 0 0 0 2-5.3 30.5 30.5 0 0 0 .8-3.7l.3-3a17.6 17.6 0 0 1 1-4.5 36.6 36.6 0 0 0 2-11 5.7 5.7 0 0 0 0-1.5 8.6 8.6 0 0 0-1-1.9l-1.5-3.5a17.3 17.3 0 0 0-5.9-6.2c-1.1-.8-2.5-1.6-3.8-1.2z"
            />
            <path
              fill="#fbbebe"
              d="M429.3 456a10.4 10.4 0 0 1-2.8-2.1l-1-1.4a6.8 6.8 0 0 0-3.4-2 16.9 16.9 0 0 0-4-.3 7.3 7.3 0 0 0-2.7.3 2.7 2.7 0 0 0-1.8 1.9 3.1 3.1 0 0 0 1.4 2.8 6.4 6.4 0 0 0 2.7 1.3 21.5 21.5 0 0 0 2.4.3c4.8.5 9 3 13.3 5.4q5.5 3.2 11.2 5.9a23.4 23.4 0 0 0 .2-3.5c0-.8 0-2.2-.9-2.7a17.7 17.7 0 0 0-3.6-1 56.3 56.3 0 0 1-7.2-3c-1.3-.5-2.6-1.2-3.8-2z"
            />
            <ellipse cx="450.2" cy="420.4" fill="#fbbebe" rx="8.5" ry="8.6" />
            <path
              fill="#2f2e41"
              d="M462 437.5a13.7 13.7 0 0 0-1.7 3.1c-1 2.2-2.7 4-3.6 6.3s-.8 5.3-2.5 7.1a2.5 2.5 0 0 0-.8 1.1 5.2 5.2 0 0 1 0 .8c-.3.7-1.4.7-1.6 1.4l-.1.6c-.2.5-.8.5-1.2.8-.8.6-.6 1.9-1.2 2.7a2.3 2.3 0 0 1-2.1.7 7.5 7.5 0 0 1-2.3-.8 2.1 2.1 0 0 0-.7-.3 1.6 1.6 0 0 0-1 .4 5.7 5.7 0 0 0-2.3 4.8 15.8 15.8 0 0 0 1.3 5.5 2.2 2.2 0 0 0 .5.8 2 2 0 0 0 2.1.1 10 10 0 0 1 2-1c1.4-.1 2.7.8 4 .7a5.5 5.5 0 0 0 2.7-1.2 14.7 14.7 0 0 0 3.6-3l1.5-2.5a31.5 31.5 0 0 1 2.1-2.8l5-6a13.8 13.8 0 0 0 1.3-1.8 12.8 12.8 0 0 0 1-2.8 21 21 0 0 0 1-4.9 18.8 18.8 0 0 0-.4-4 14.5 14.5 0 0 0-1-4c-1-2.2-3.7-4-5.7-1.7z"
            />
            <path
              fill="#f86d70"
              d="M479 426.4a9.6 9.6 0 0 0-3.9-7.8 11.4 11.4 0 0 0-9.7-11.1 11 11 0 0 0-21.8.5c-3.5-.8-6.8.3-7.4 2.5s2 5 5.7 6a10.5 10.5 0 0 0 3.6.3 11 11 0 0 0 7.6 4.8 11.4 11.4 0 0 0 8.3 8.6 9.6 9.6 0 0 0 2.6 3.5v.8a7.2 7.2 0 1 0 14.4 0 7.7 7.7 0 0 0-.7-3.2 9.6 9.6 0 0 0 1.4-5z"
            />
            <path
              d="M438.6 411c.6-2.3 3.9-3.3 7.4-2.5a11.3 11.3 0 0 1 11-9.5h.7a10.8 10.8 0 0 0-3.1-.4 11.3 11.3 0 0 0-11 9.4c-3.5-.8-6.8.3-7.4 2.5s2 5 5.7 6a11 11 0 0 0 2.1.3c-3.6-1-6-3.6-5.4-5.9zM466.4 435a7.5 7.5 0 0 1 0-.9 9.3 9.3 0 0 1-2.6-3.5 11.3 11.3 0 0 1-8.3-8.6 11 11 0 0 1-7.6-4.7 9.6 9.6 0 0 1-2.2-.1 11.1 11.1 0 0 0 7.4 4.4 11.4 11.4 0 0 0 8.3 8.6 9.6 9.6 0 0 0 2.6 3.5v.8a7.3 7.3 0 0 0 7.1 7.5 7.5 7.5 0 0 1-4.7-7z"
              opacity=".1"
            />
            <ellipse
              cx="505"
              cy="584.7"
              fill="#fbbebe"
              rx="1.3"
              ry="1.8"
              transform="rotate(-37.2 237.5 580.6)"
            />
          </svg>
        </div>
        <form
          className="form"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <h2 className="h2">Contact Me</h2>
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact" />
          <label>Name *</label>
          <input required type="text" name="name" />
          <label>Email *</label>
          <input required type="email" name="email" />
          <label>Message *</label>
          <textarea name="message"></textarea>
          <button required className="btn btn-primary" type="submit">
            Send
          </button>
        </form>
      </div>
    </section>
  );
}

export default ContactMe;
